import classNames from 'classnames';
import React, { ComponentProps, PropsWithChildren } from 'react';

import { ElementTypes } from '../../util/types';

import styles from './SubtleLink.module.css';

interface OwnProps<E extends ElementTypes> {
  element?: E;
}

type Props<E extends ElementTypes> = PropsWithChildren<
  OwnProps<E> & Omit<ComponentProps<E>, keyof OwnProps<E>>
>;

export default function SubtleLink<E extends ElementTypes>({
  element,
  className,
  children,
  ...props
}: Props<E>) {
  const Element = element ?? 'a';
  return (
    <Element className={classNames(styles.SubtleLink, className)} {...props}>
      {children}
    </Element>
  );
}
